import { Outlet, useParams } from "react-router-dom";
import { useGetNazivAndStatusProjekta } from "../services/ProjectDetails/projectDetailsAPI";

import { Card, Row, Col, Container } from "react-bootstrap";
import NavTabs from "./ui/NavTabs";
import StatusProjektaPanel from "./projectDetailsV2/statusProjektaPanel/StatusProjektaPanel";
import { projectDetailsV2Tabs } from "../config/navItemsProjectsDetailsV2";
import MdocsPanel from "./projectDetailsV2/mdocsPanel/MdocsPanel";
import RoleGuard from "../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../auth/roles";
import AccessDenied from "./ui/AccessDenied";
import ProjectDetailsContext from "../context/ProjectDetailsContext";
import useVisibleTabs from "../auth/useVisibleTabs";

const ProjectDetailsV2 = () => {
  const { id } = useParams();

  const {
    data: project,
    isLoading,
    isError,
    error,
  } = useGetNazivAndStatusProjekta(id);

  // Get visible tabs based on user roles
  const visibleTabs = useVisibleTabs(projectDetailsV2Tabs);

  if (isError) {
    if (error.status === 404) {
      return (
        <Container fluid>
          <Row className="mb-2">
            <Col>
              <h1 className="projectDetails-project-title">
                Projekt ni bil najden
              </h1>
              <p>Projekt z tem ID-jem ne obstaja.</p>
            </Col>
          </Row>
        </Container>
      );
    }
  }

  return (
    <RoleGuard
      moduleKey={MODULES.PROJEKTI}
      roles={ROLE_GROUPS.ALL}
      fallback={<AccessDenied />}
    >
      <ProjectDetailsContext.Provider value={{ project, isLoading }}>
        <Container fluid>
          <Row className="mb-2">
            <Col>
              <h1 className="projectDetails-project-title">{project?.naziv}</h1>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col>
              <StatusProjektaPanel />
            </Col>
          </Row>
          <RoleGuard
            moduleKey={MODULES.PROJEKTI}
            roles={ROLE_GROUPS.GLOBALNI_AND_FAKULTETNI}
            vodilnaClanicaProjektaID={project?.clanicaID}
          >
            <Row className="mb-2">
              <Col>
                <MdocsPanel />
              </Col>
            </Row>
          </RoleGuard>
          <Row className="mt-3">
            <Col>
              <NavTabs listOfTabs={visibleTabs} />
              <div className="mt-4">
                <Outlet />
              </div>
            </Col>
          </Row>
        </Container>
      </ProjectDetailsContext.Provider>
    </RoleGuard>
  );
};
export default ProjectDetailsV2;
